import { styled } from '@mui/material';
import React from 'react';

import { useToggle } from 'hooks';
import ApplicationHeader from 'ui/ApplicationHeader';
import Navigation from 'ui/Navigation';
import { DRAWER_WIDTH } from 'constants/sizing';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  // padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: '0px',
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `${DRAWER_WIDTH}px`,
  }),
}));

interface IProps {
  children: React.ReactNode;
}

const Layout = ({ children }: IProps) => {
  const { val: isSidebarOpen, toggle: toggleIsSidebarOpen } = useToggle(false);
  return (
    <>
      <ApplicationHeader
        open={isSidebarOpen}
        onChangeOpen={toggleIsSidebarOpen}
      />
      <Navigation open={isSidebarOpen} onChangeOpen={toggleIsSidebarOpen} />
      <Main open={isSidebarOpen}>{children}</Main>
    </>
  );
};

export default Layout;
